import React from "react";
import Widget from "components/Widget";
import VitaminList from "components/Table/List";
import ActionMenu from "components/Table/Actions/ActionDropdown";
import Layout from "components/Layout";
import DeleteConfirm from "components/Modal/DeleteConfirm";
import EditVitamin from "./components/EditVitamin";
import ShowModal from "components/Modal/ShowModal";
import AddNewVitamin from "./components/AddVitamin";
import SearchBox from "components/Filters/SearchBox";
import UploadCSV from "components/uploadCSV";
import { Tag } from "antd";
const Vitamin = () => {
  const columns = [
    {
      title: " Name",
      render: (record) => <span>{record.vitaminName}</span>,
      key: "Name",
    },

    {
      title: " ",
      render: (record) => <ActionMenu menu={renderActions(record)} />,
      key: "action",
      width: "50px",
    },
  ];

  const renderActions = (record) => {
    return (
      <div className="gx-d-flex gx-flex-column gx-pointer ">
        <ShowModal
          record={record}
          modalName={"Edit_Vitamin_Modal"}
          buttonName="Edit"
        />
        <DeleteConfirm
          type="deleteVitamin"
          recordName="vitaminList"
          method="DELETE"
          selectedItem={record}
          apiRequest="DeleteRecord"
          buttonName="Yes"
          oKText="Delete"
          title="Are you sure you want to delete this Vitamin?"
          Icon="Delete"
        />
      </div>
    );
  };

  return (
    <Layout>
      <Widget
        styleName="mainTable"
        title={
          <div className="gx-d-flex gx-flex-column">
            <span>VITAMINS</span>
            <a
              className="gx-m-0"
              href="https://painles.s3.amazonaws.com/1654281829117-vitaminName-1%20-%20Sheet1.csv"
            >
              <Tag className="gx-m-0" color="blue">
                Download CSV Sample
              </Tag>
            </a>
          </div>
        }
        extra={
          <div className="gx-d-flex" style={{ gap: "20px" }}>
            <SearchBox
              apiName="getVitamins"
              recordName="vitaminList"
              requestType="FetchRecord"
              customQuery={{ query: "search", key: "name" }}
              placeholder="Search By Name"
              width="200px"
            />
            <UploadCSV
              type="getVitamins"
              url="bulkImportSkills"
              table="Vitamin"
              recordName="vitaminList"
              cb="vitaminName"
              uId="vitaminId"
            />
            <AddNewVitamin />
          </div>
        }
      >
        <VitaminList
          recordName="vitaminList"
          apiName="getVitamins"
          columns={columns}
        />
      </Widget>
      <EditVitamin />
    </Layout>
  );
};

export default Vitamin;
